module.exports = __webpack_public_path__ + "static/media/Janet Grice_front cover.a6160a98.jpg";